import React from 'react';
import { usePortal } from '@dm/react-hooks';
import { useFela } from '../..';
import ThemeProps from '../../Theme/ThemeProps';

const containerStyle = ({ theme }: { theme: ThemeProps }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  position: 'fixed',
  zIndex: theme.dimension.zIndex.fixed,
  right: theme.dimension.spacing.xxxs.rem,
  bottom: theme.dimension.spacing.xxxs.rem,
  left: theme.dimension.spacing.xxxs.rem,
  [theme.breakpoints.horizontal.s.mediaQuery]: {
    right: theme.dimension.spacing.xxs.rem,
    bottom: theme.dimension.spacing.xxs.rem,
    left: 'auto',
    width: '400px',
  },
});

function NotificationContainer({
  dmId = 'notification-container',
  children,
  style,
}: {
  dmId: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  const { Portal } = usePortal({
    closeOnOutsideClick: false,
    closeOnEsc: false,
  });
  const { css } = useFela();

  return (
    // @ts-ignore
    <Portal>
      <div data-dmid={dmId} className={css([containerStyle, style])}>
        {children}
      </div>
    </Portal>
  );
}

export default NotificationContainer;
